module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed"
  }, [_c('section', {
    staticClass: "posts row"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "post col-md-4 col-xs-12 post-wrapper"
    }, [_c('md-card', [_c('md-card-media', {
      staticClass: "post-header",
      style: ({
        'background-image': 'url(' + post.image + ')'
      })
    }), _vm._v(" "), _c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(post.title.rendered))])]), _vm._v(" "), _c('md-card-content', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(post.excerpt.rendered)
      }
    })]), _vm._v(" "), _c('md-card-actions', [_c('a', {
      attrs: {
        "href": post.link
      }
    }, [_vm._v(_vm._s(_vm.$t("read_more")))])])], 1)], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bc4e308!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedView.vue
// module id = 418
// module chunks = 2